import React from 'react';

import PropTypes from 'prop-types';

import {
    CarrierLogo,
    TooltipController,
    TooltipSelect,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './ScheduleCarrierInfo.scss';

function SingleCarrierInfo(props) {
    const {
        t,
        carrierCode,
        carrierName,
        tripModes,
    } = props;
    const tooltipText = `${carrierName} (${tripModes.map((m) => t(`baseApp:${m}`)).join(' + ')})`;

    return (
        <TooltipController offsetX="center">
            <TooltipSelect>
                <CarrierLogo
                    carrierCode={carrierCode}
                    carrierName={carrierName || carrierCode}
                    className={styles.carrierLogo}
                    lazyload={false}
                    tooltip={carrierName}
                />
            </TooltipSelect>
            {carrierName && (
                <div>{tooltipText}</div>
            )}
        </TooltipController>
    );
}

function ScheduleCarrierInfo(props) {
    const {
        className,
        isRouted,
        t,
    } = props;

    return (
        <div className={className}>
            {isRouted
                ? t('baseApp:multiple-carriers_tripDetails')
                : <SingleCarrierInfo {...props} />}
        </div>
    );
}

ScheduleCarrierInfo.propTypes = {
    carrierCode: PropTypes.string.isRequired,
    carrierName: PropTypes.string,
    className: PropTypes.string,
    isRouted: PropTypes.bool,
    tripModes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

ScheduleCarrierInfo.defaultProps = {
    carrierName: '',
    className: '',
    isRouted: false,
};

export { ScheduleCarrierInfo };
export default localize(ScheduleCarrierInfo);
